import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { JsonApiDatastore, JsonApiDatastoreConfig } from 'angular2-jsonapi'
import { CookieService } from 'ngx-cookie-service'

import { environment } from '../../environments/environment'
import { Bureau } from './core/bureau.model'
import { UserConnection } from './core/user-connection.model'
import { Foto } from './core/foto.model'

@Injectable()
@JsonApiDatastoreConfig({
    baseUrl: environment.identificacaoUrl,
    models: {
        'user-connections': UserConnection,
        bureaus: Bureau,
        fotos: Foto,
    },
})
export class PkwDatastoreIdentificacao extends JsonApiDatastore {
    constructor(http: HttpClient, private cookieService: CookieService) {
        super(http)
    }

    protected buildHeaders(customHeaders?: Headers) {
        if (!customHeaders) {
            customHeaders = new Headers()
        }

        const jwt = this.cookieService.get('jwt')
        customHeaders.set('Authorization', `Bearer ${jwt}`)

        return super.buildHeaders(customHeaders)
    }
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/pkw-datastore-identificacao.ts